import {
  AntiCompetitiveBehaviorKey,
  AntiCompetitiveBehaviorLabel,
  AntiCorruptionKey,
  AntiCorruptionLabel,
  EconomicPerformanceKey,
  EconomicPerformanceLabel,
  IndirectEconomicImpactsKey,
  IndirectEconomicImpactsLabel,
  MarketingAndLabelingKey,
  MarketingAndLabelingLabel,
  ProcurementPracticesKey,
  ProcurementPracticesLabel,
  PublicPolicyKey,
  PublicPolicyLabel,
  TaxKey,
  TaxLabel
} from '../../../../components/Forms/Constants/Governance/QuestionsKeyLabel';
import {inputType} from '../../interface/inputType';

/* eslint-disable max-len */
export const publicPolicyTabQuestions = [
  {
    key: '1',
    label: PublicPolicyLabel.PP_PUBLIC_POLICY_1,
    kpiId: '415-1',
    items: [
      {
        question:
          'a. Total monetary value of financial and in-kind political contributions made directly and indirectly by the organization by country and recipient/beneficiary',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: PublicPolicyKey.PP_QUESTION_1,
            fieldLabel: PublicPolicyLabel.PP_QUESTION_1,
            tooltip:
              'Financial or in-kind support given directly or indirectly to political parties, their elected representatives, or persons seeking political officeNote 1: Financial contributions can include donations, loans, sponsorships, retainers, or the purchase of tickets for fundraising events. Note 2: In-kind contributions can include advertising, use of facilities, design and printing, donation of equipment, or the provision of board membership, employment or consultancy work for elected politicians or candidates for office.'
          }
        ]
      },
      {
        question:
          'b. If applicable, how the monetary value of in-kind contributions was estimated.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: PublicPolicyKey.PP_QUESTION_2,
            fieldLabel: PublicPolicyLabel.PP_QUESTION_2,
            tooltip:
              'Financial or in-kind support given directly or indirectly to political parties, their elected representatives, or persons seeking political officeNote 1: Financial contributions can include donations, loans, sponsorships, retainers, or the purchase of tickets for fundraising events. Note 2: In-kind contributions can include advertising, use of facilities, design and printing, donation of equipment, or the provision of board membership, employment or consultancy work for elected politicians or candidates for office.'
          }
        ]
      }
    ]
  }
];

export const marketingAndLabelingTabQuestions = [
  {
    key: '1',
    label: MarketingAndLabelingLabel.MAL_MARKETING_AND_LABELING_1,
    kpiId: '417-1',
    items: [
      {
        question:
          'a. Whether each of the following types of information is required by the organization’s procedures for product and service information and labeling: ',
        field: [
          {
            fieldType: inputType.HEADING,
            heading: MarketingAndLabelingLabel.MAL_HEADING_1
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: MarketingAndLabelingKey.MAL_QUESTION_1,
            fieldLabel: MarketingAndLabelingLabel.MAL_QUESTION_1
          },
          {
            fieldType: inputType.HEADING,
            heading: MarketingAndLabelingLabel.MAL_HEADING_2
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: MarketingAndLabelingKey.MAL_QUESTION_2,
            fieldLabel: MarketingAndLabelingLabel.MAL_QUESTION_2
          },
          {
            fieldType: inputType.HEADING,
            heading: MarketingAndLabelingLabel.MAL_HEADING_3
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: MarketingAndLabelingKey.MAL_QUESTION_3,
            fieldLabel: MarketingAndLabelingLabel.MAL_QUESTION_3
          },
          {
            fieldType: inputType.HEADING,
            heading: MarketingAndLabelingLabel.MAL_HEADING_4
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: MarketingAndLabelingKey.MAL_QUESTION_4,
            fieldLabel: MarketingAndLabelingLabel.MAL_QUESTION_4
          },
          {
            fieldType: inputType.HEADING,
            heading: MarketingAndLabelingLabel.MAL_HEADING_5
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: MarketingAndLabelingKey.MAL_QUESTION_5,
            fieldLabel: MarketingAndLabelingLabel.MAL_QUESTION_5
          }
        ]
      },
      {
        question:
          'b. Percentage of significant product or service categories covered by and assessed for compliance with such procedures.',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: MarketingAndLabelingKey.MAL_QUESTION_6,
            fieldLabel: MarketingAndLabelingLabel.MAL_QUESTION_6
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: MarketingAndLabelingKey.MAL_QUESTION_7,
            fieldLabel: MarketingAndLabelingLabel.MAL_QUESTION_7
          }
        ]
      }
    ]
  },
  {
    key: '2',
    label: MarketingAndLabelingLabel.MAL_MARKETING_AND_LABELING_2,
    kpiId: '417-2',
    items: [
      {
        question:
          'a. Total number of incidents of non-compliance with regulations and/or voluntary codes concerning product and service information and labeling, by: ',
        field: [
          {
            fieldType: inputType.HEADING,
            heading: MarketingAndLabelingLabel.MAL_HEADING_6
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: MarketingAndLabelingKey.MAL_QUESTION_8,
            fieldLabel: MarketingAndLabelingLabel.MAL_QUESTION_8
          },
          {
            fieldType: inputType.HEADING,
            heading: MarketingAndLabelingLabel.MAL_HEADING_7
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: MarketingAndLabelingKey.MAL_QUESTION_9,
            fieldLabel: MarketingAndLabelingLabel.MAL_QUESTION_9
          },
          {
            fieldType: inputType.HEADING,
            heading: MarketingAndLabelingLabel.MAL_HEADING_8
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: MarketingAndLabelingKey.MAL_QUESTION_10,
            fieldLabel: MarketingAndLabelingLabel.MAL_QUESTION_10
          }
        ]
      },
      {
        question:
          'b. If the organization has not identified any non-compliance with regulations and/or voluntary codes, a brief statement of this fact is sufficient.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: MarketingAndLabelingKey.MAL_QUESTION_11,
            fieldLabel: MarketingAndLabelingLabel.MAL_QUESTION_11
          }
        ]
      }
    ]
  },
  {
    key: '3',
    label: MarketingAndLabelingLabel.MAL_MARKETING_AND_LABELING_3,
    kpiId: '417-3',
    items: [
      {
        question:
          'a. Total number of incidents of non-compliance with regulations and/or voluntary codes concerning marketing communications, including advertising, promotion, and sponsorship, by: ',
        field: [
          {
            fieldType: inputType.HEADING,
            heading: MarketingAndLabelingLabel.MAL_HEADING_9
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: MarketingAndLabelingKey.MAL_QUESTION_12,
            fieldLabel: MarketingAndLabelingLabel.MAL_QUESTION_12
          },
          {
            fieldType: inputType.HEADING,
            heading: MarketingAndLabelingLabel.MAL_HEADING_10
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: MarketingAndLabelingKey.MAL_QUESTION_13,
            fieldLabel: MarketingAndLabelingLabel.MAL_QUESTION_13
          },
          {
            fieldType: inputType.HEADING,
            heading: MarketingAndLabelingLabel.MAL_HEADING_11
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: MarketingAndLabelingKey.MAL_QUESTION_14,
            fieldLabel: MarketingAndLabelingLabel.MAL_QUESTION_14
          }
        ]
      },
      {
        question:
          'b. If the organization has not identified any non-compliance with regulations and/or voluntary codes, a brief statement of this fact is sufficient.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: MarketingAndLabelingKey.MAL_QUESTION_15,
            fieldLabel: MarketingAndLabelingLabel.MAL_QUESTION_15
          }
        ]
      }
    ]
  },
  {
    key: '4',
    label: MarketingAndLabelingLabel.MAL_MARKETING_AND_LABELING_4,
    kpiId: '418-1',
    items: [
      {
        question:
          'a. Total number of substantiated complaints received concerning breaches of customer privacy, categorized by: ',
        field: [
          {
            fieldType: inputType.HEADING,
            heading: MarketingAndLabelingLabel.MAL_HEADING_12
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: MarketingAndLabelingKey.MAL_QUESTION_16,
            fieldLabel: MarketingAndLabelingLabel.MAL_QUESTION_16
          },
          {
            fieldType: inputType.HEADING,
            heading: MarketingAndLabelingLabel.MAL_HEADING_13
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: MarketingAndLabelingKey.MAL_QUESTION_17,
            fieldLabel: MarketingAndLabelingLabel.MAL_QUESTION_17
          }
        ]
      },
      {
        question:
          'b. Total number of identified leaks, thefts, or losses of customer data.',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: MarketingAndLabelingKey.MAL_QUESTION_18,
            fieldLabel: MarketingAndLabelingLabel.MAL_QUESTION_18
          }
        ]
      },
      {
        question:
          'c. If the organization has not identified any substantiated complaints, a brief statement of this fact is sufficient.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: MarketingAndLabelingKey.MAL_QUESTION_19,
            fieldLabel: MarketingAndLabelingLabel.MAL_QUESTION_19
          }
        ]
      }
    ]
  }
];

export const economicPerformanceTabQuestions = [
  {
    key: '1',
    label: EconomicPerformanceLabel.EP_ECONOMIC_PERFORMANCE_1,
    kpiId: '201-1',
    items: [
      {
        question:
          'a. Direct economic value generated and distributed (EVG&D) on an accruals basis, including the basic components for the organization’s global operations as listed below. If data are presented on a cash basis, report the justification for this decision in addition to reporting the following basic components:',
        field: [
          {
            fieldType: inputType.HEADING,
            heading: EconomicPerformanceLabel.EP_HEADING_1
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EconomicPerformanceKey.EP_QUESTION_1,
            fieldLabel: EconomicPerformanceLabel.EP_QUESTION_1
          },
          {
            fieldType: inputType.HEADING,
            heading: EconomicPerformanceLabel.EP_HEADING_2
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EconomicPerformanceKey.EP_QUESTION_2,
            fieldLabel: EconomicPerformanceLabel.EP_QUESTION_2
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EconomicPerformanceKey.EP_QUESTION_3,
            fieldLabel: EconomicPerformanceLabel.EP_QUESTION_3
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EconomicPerformanceKey.EP_QUESTION_4,
            fieldLabel: EconomicPerformanceLabel.EP_QUESTION_4
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EconomicPerformanceKey.EP_QUESTION_5,
            fieldLabel: EconomicPerformanceLabel.EP_QUESTION_5
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EconomicPerformanceKey.EP_QUESTION_6,
            fieldLabel: EconomicPerformanceLabel.EP_QUESTION_6
          },
          {
            fieldType: inputType.HEADING,
            heading: EconomicPerformanceLabel.EP_HEADING_3
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EconomicPerformanceKey.EP_QUESTION_7,
            fieldLabel: EconomicPerformanceLabel.EP_QUESTION_7
          }
        ]
      },
      {
        question:
          'b. Where significant, report EVG&D separately at country, regional, or market levels, and the criteria used for defining significance',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: EconomicPerformanceKey.EP_QUESTION_8,
            fieldLabel: EconomicPerformanceLabel.EP_QUESTION_8
          }
        ]
      }
    ]
  },
  {
    key: '2',
    label: EconomicPerformanceLabel.EP_ECONOMIC_PERFORMANCE_2,
    kpiId: '201-2',
    items: [
      {
        question:
          'a. Risks and opportunities posed by climate change that have the potential to generate substantive changes in operations, revenue, or expenditure, including:',
        field: [
          {
            fieldType: inputType.HEADING,
            heading: EconomicPerformanceLabel.EP_HEADING_4
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: EconomicPerformanceKey.EP_QUESTION_9,
            fieldLabel: EconomicPerformanceLabel.EP_QUESTION_9
          },
          {
            fieldType: inputType.HEADING,
            heading: EconomicPerformanceLabel.EP_HEADING_5
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: EconomicPerformanceKey.EP_QUESTION_10,
            fieldLabel: EconomicPerformanceLabel.EP_QUESTION_10
          },
          {
            fieldType: inputType.HEADING,
            heading: EconomicPerformanceLabel.EP_HEADING_6
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: EconomicPerformanceKey.EP_QUESTION_11,
            fieldLabel: EconomicPerformanceLabel.EP_QUESTION_11
          },
          {
            fieldType: inputType.HEADING,
            heading: EconomicPerformanceLabel.EP_HEADING_7
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: EconomicPerformanceKey.EP_QUESTION_12,
            fieldLabel: EconomicPerformanceLabel.EP_QUESTION_12
          },
          {
            fieldType: inputType.HEADING,
            heading: EconomicPerformanceLabel.EP_HEADING_8
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: EconomicPerformanceKey.EP_QUESTION_13,
            fieldLabel: EconomicPerformanceLabel.EP_QUESTION_13
          }
        ]
      }
    ]
  },
  {
    key: '3',
    label: EconomicPerformanceLabel.EP_ECONOMIC_PERFORMANCE_3,
    kpiId: '201-3',
    items: [
      {
        question:
          'a. If the plan’s liabilities are met by the organization’s general resources, the estimated value of those liabilities.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: EconomicPerformanceKey.EP_QUESTION_14,
            fieldLabel: EconomicPerformanceLabel.EP_QUESTION_14
          }
        ]
      },
      {
        question:
          'b. If a separate fund exists to pay the plan’s pension liabilities: ',
        field: [
          {
            fieldType: inputType.HEADING,
            heading: EconomicPerformanceLabel.EP_HEADING_9
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: EconomicPerformanceKey.EP_QUESTION_15,
            fieldLabel: EconomicPerformanceLabel.EP_QUESTION_15
          },
          {
            fieldType: inputType.HEADING,
            heading: EconomicPerformanceLabel.EP_HEADING_10
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: EconomicPerformanceKey.EP_QUESTION_16,
            fieldLabel: EconomicPerformanceLabel.EP_QUESTION_16
          },
          {
            fieldType: inputType.HEADING,
            heading: EconomicPerformanceLabel.EP_HEADING_11
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: EconomicPerformanceKey.EP_QUESTION_17,
            fieldLabel: EconomicPerformanceLabel.EP_QUESTION_17
          }
        ]
      },
      {
        question:
          'c. If a fund set up to pay the plan’s pension liabilities is not fully covered, explain the strategy,  if any, adopted by the employer to work towards full coverage, and the timescale, if any,  by which the employer hopes to achieve full coverage.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: EconomicPerformanceKey.EP_QUESTION_18,
            fieldLabel: EconomicPerformanceLabel.EP_QUESTION_18
          }
        ]
      },
      {
        question:
          'd. Percentage of salary contributed by employee or employer.',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: EconomicPerformanceKey.EP_QUESTION_19,
            fieldLabel: EconomicPerformanceLabel.EP_QUESTION_19
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EconomicPerformanceKey.EP_QUESTION_20,
            fieldLabel: EconomicPerformanceLabel.EP_QUESTION_20
          }
        ]
      },
      {
        question:
          'e. Level of participation in retirement plans, such as participation in mandatory or voluntary schemes, regional, or country-based schemes, or those with financial impact.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: EconomicPerformanceKey.EP_QUESTION_21,
            fieldLabel: EconomicPerformanceLabel.EP_QUESTION_21
          }
        ]
      }
    ]
  },
  {
    key: '4',
    label: EconomicPerformanceLabel.EP_ECONOMIC_PERFORMANCE_4,
    kpiId: '201-4',
    items: [
      {
        question:
          'a. Total monetary value of financial assistance received by the organization from any government during the reporting period, including: ',
        field: [
          {
            fieldType: inputType.HEADING,
            heading: EconomicPerformanceLabel.EP_HEADING_12
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EconomicPerformanceKey.EP_QUESTION_22,
            fieldLabel: EconomicPerformanceLabel.EP_QUESTION_22
          },
          {
            fieldType: inputType.HEADING,
            heading: EconomicPerformanceLabel.EP_HEADING_13
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EconomicPerformanceKey.EP_QUESTION_23,
            fieldLabel: EconomicPerformanceLabel.EP_QUESTION_23
          },
          {
            fieldType: inputType.HEADING,
            heading: EconomicPerformanceLabel.EP_HEADING_14
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EconomicPerformanceKey.EP_QUESTION_24,
            fieldLabel: EconomicPerformanceLabel.EP_QUESTION_24
          },
          {
            fieldType: inputType.HEADING,
            heading: EconomicPerformanceLabel.EP_HEADING_15
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EconomicPerformanceKey.EP_QUESTION_25,
            fieldLabel: EconomicPerformanceLabel.EP_QUESTION_25
          },
          {
            fieldType: inputType.HEADING,
            heading: EconomicPerformanceLabel.EP_HEADING_16
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EconomicPerformanceKey.EP_QUESTION_26,
            fieldLabel: EconomicPerformanceLabel.EP_QUESTION_26
          },
          {
            fieldType: inputType.HEADING,
            heading: EconomicPerformanceLabel.EP_HEADING_17
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EconomicPerformanceKey.EP_QUESTION_27,
            fieldLabel: EconomicPerformanceLabel.EP_QUESTION_27
          },
          {
            fieldType: inputType.HEADING,
            heading: EconomicPerformanceLabel.EP_HEADING_18
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EconomicPerformanceKey.EP_QUESTION_28,
            fieldLabel: EconomicPerformanceLabel.EP_QUESTION_28
          },
          {
            fieldType: inputType.HEADING,
            heading: EconomicPerformanceLabel.EP_HEADING_19
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EconomicPerformanceKey.EP_QUESTION_29,
            fieldLabel: EconomicPerformanceLabel.EP_QUESTION_29
          }
        ]
      },
      {
        question: 'b. The information in 201-4-a by country.',
        field: [
          {
            fieldType: inputType.ADD_MORE_FIELDS,
            colSpan: true,
            formList: {
              name: 'informationIn201-4-aByCountry',
              formFields: [
                {
                  type: inputType.COUNTRY,
                  fieldName: EconomicPerformanceKey.EP_QUESTION_30,
                  fieldLabel: EconomicPerformanceLabel.EP_HEADING_28
                },
                {
                  type: inputType.NUMBER,
                  fieldName: EconomicPerformanceKey.EP_QUESTION_31,
                  fieldLabel: EconomicPerformanceLabel.EP_HEADING_20
                },
                {
                  type: inputType.NUMBER,
                  fieldName: EconomicPerformanceKey.EP_QUESTION_32,
                  fieldLabel: EconomicPerformanceLabel.EP_HEADING_21
                },
                {
                  type: inputType.NUMBER,
                  fieldName: EconomicPerformanceKey.EP_QUESTION_33,
                  fieldLabel: EconomicPerformanceLabel.EP_HEADING_22
                },
                {
                  type: inputType.NUMBER,
                  fieldName: EconomicPerformanceKey.EP_QUESTION_34,
                  fieldLabel: EconomicPerformanceLabel.EP_HEADING_23
                },
                {
                  type: inputType.NUMBER,
                  fieldName: EconomicPerformanceKey.EP_QUESTION_35,
                  fieldLabel: EconomicPerformanceLabel.EP_HEADING_24
                },
                {
                  type: inputType.NUMBER,
                  fieldName: EconomicPerformanceKey.EP_QUESTION_36,
                  fieldLabel: EconomicPerformanceLabel.EP_HEADING_25
                },
                {
                  type: inputType.NUMBER,
                  fieldName: EconomicPerformanceKey.EP_QUESTION_37,
                  fieldLabel: EconomicPerformanceLabel.EP_HEADING_26
                },
                {
                  type: inputType.NUMBER,
                  fieldName: EconomicPerformanceKey.EP_QUESTION_38,
                  fieldLabel: EconomicPerformanceLabel.EP_HEADING_27
                }
              ]
            }
          }
        ]
      },
      {
        question:
          'c. Whether, and the extent to which, any government is present in the shareholding structure.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: EconomicPerformanceKey.EP_QUESTION_39,
            fieldLabel: EconomicPerformanceLabel.EP_QUESTION_39
          }
        ]
      }
    ]
  }
];

export const indirectEconomicImpactsTabQuestions = [
  {
    key: '1',
    label: IndirectEconomicImpactsLabel.IEI_INDIRECT_ECONOMIC_IMPACTS_1,
    kpiId: '203-1',
    items: [
      {
        question:
          'a. Extent of development of significant infrastructure investments and services supported.',
        tooltip:
          'When compiling the information specified in Disclosure 203-1, the reporting organization should disclose: · the size, cost and duration of each significant infrastructure investment or service supported · the extent to which different communities or local economies are impacted by the organization’s infrastructure investments and services supported',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: IndirectEconomicImpactsKey.IEI_QUESTION_1,
            fieldLabel: IndirectEconomicImpactsLabel.IEI_QUESTION_1
          }
        ]
      },
      {
        question:
          'b. Current or expected impacts on communities and local economies, including positive and negative impacts where relevant.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: IndirectEconomicImpactsKey.IEI_QUESTION_2,
            fieldLabel: IndirectEconomicImpactsLabel.IEI_QUESTION_2
          }
        ]
      },
      {
        question:
          'c. Whether these investments and services are commercial, in-kind, or pro bono engagements.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: IndirectEconomicImpactsKey.IEI_QUESTION_3,
            fieldLabel: IndirectEconomicImpactsLabel.IEI_QUESTION_3
          }
        ]
      }
    ]
  },
  {
    key: '2',
    label: IndirectEconomicImpactsLabel.IEI_INDIRECT_ECONOMIC_IMPACTS_2,
    kpiId: '203-2',
    items: [
      {
        question:
          'a. Examples of significant identified indirect economic impacts of the organization, including positive and negative impacts.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: IndirectEconomicImpactsKey.IEI_QUESTION_4,
            fieldLabel: IndirectEconomicImpactsLabel.IEI_QUESTION_4
          }
        ]
      },
      {
        question:
          'b. Significance of the indirect economic impacts in the context of external benchmarks and stakeholder priorities, such as national and international standards, protocols, and policy agendas.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: IndirectEconomicImpactsKey.IEI_QUESTION_5,
            fieldLabel: IndirectEconomicImpactsLabel.IEI_QUESTION_5
          }
        ]
      }
    ]
  }
];

export const procurementPracticesTabQuestions = [
  {
    key: '1',
    label: ProcurementPracticesLabel.PP_PROCUREMENT_PRACTICES_1,
    kpiId: '204-1',
    items: [
      {
        question:
          'a. Percentage of the procurement budget used for significant locations of operation that is spent on suppliers local to that operation (such as percentage of products and services purchased locally).',
        tooltip:
          'Local purchases can be made either from a budget managed at the location of operation or at an organization’s headquarters.',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: ProcurementPracticesKey.PP_QUESTION_1,
            fieldLabel: ProcurementPracticesLabel.PP_QUESTION_1
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: ProcurementPracticesKey.PP_QUESTION_2,
            fieldLabel: ProcurementPracticesLabel.PP_QUESTION_2
          }
        ]
      },
      {
        question: 'b. The organization’s geographical definition of ‘local’.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: ProcurementPracticesKey.PP_QUESTION_3,
            fieldLabel: ProcurementPracticesLabel.PP_QUESTION_3
          }
        ]
      },
      {
        question:
          'c. The definition used for ‘significant locations of operation’.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: ProcurementPracticesKey.PP_QUESTION_4,
            fieldLabel: ProcurementPracticesLabel.PP_QUESTION_4
          }
        ]
      }
    ]
  }
];

export const antiCorruptionTabQuestions = [
  {
    key: '1',
    label: AntiCorruptionLabel.AC_ANTI_CORRUPTION_1,
    kpiId: '205-1',
    items: [
      {
        question:
          'a. Total number of operations assessed for risks related to corruption.',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: AntiCorruptionKey.AC_QUESTION_1,
            fieldLabel: AntiCorruptionLabel.AC_QUESTION_1
          }
        ]
      },
      {
        question:
          'Percentage of operations assessed for risks related to corruption.',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: AntiCorruptionKey.AC_QUESTION_2,
            fieldLabel: AntiCorruptionLabel.AC_QUESTION_2
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: AntiCorruptionKey.AC_QUESTION_3,
            fieldLabel: AntiCorruptionLabel.AC_QUESTION_3
          }
        ]
      },
      {
        question:
          'b. Significant risks related to corruption identified through the risk assessment.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: AntiCorruptionKey.AC_QUESTION_4,
            fieldLabel: AntiCorruptionLabel.AC_QUESTION_4
          }
        ]
      }
    ]
  },
  {
    key: '2',
    label: AntiCorruptionLabel.AC_ANTI_CORRUPTION_2,
    kpiId: '205-2',
    items: [
      {
        question:
          'a. Total number of governance body members that the organization’s anti-corruption policies and procedures have been communicated to, broken down by region.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: AntiCorruptionKey.AC_QUESTION_5,
            fieldLabel: AntiCorruptionLabel.AC_QUESTION_5
          }
        ]
      },
      {
        question:
          'Percentage of governance body members that the organization’s anti-corruption policies and procedures have been communicated to, broken down by region.',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: AntiCorruptionKey.AC_QUESTION_6,
            fieldLabel: AntiCorruptionLabel.AC_QUESTION_6
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: AntiCorruptionKey.AC_QUESTION_7,
            fieldLabel: AntiCorruptionLabel.AC_QUESTION_7
          }
        ]
      },
      {
        question:
          'b. Total number of employees that the organization’s anti-corruption policies and procedures have been communicated to, broken down by employee category and region',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: AntiCorruptionKey.AC_QUESTION_8,
            fieldLabel: AntiCorruptionLabel.AC_QUESTION_8
          }
        ]
      },
      {
        question:
          'Percentage of employees that the organization’s anti-corruption policies  and procedures have been communicated to, broken down by employee category and region',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: AntiCorruptionKey.AC_QUESTION_9,
            fieldLabel: AntiCorruptionLabel.AC_QUESTION_9
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: AntiCorruptionKey.AC_QUESTION_10,
            fieldLabel: AntiCorruptionLabel.AC_QUESTION_10
          }
        ]
      },
      {
        question:
          'c. Total number of business partners that the organization’s anti-corruption policies and procedures have been communicated to, broken down by type of business partner and region. Describe if the organization’s anti-corruption policies and procedures have been communicated to any other persons or organizations.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: AntiCorruptionKey.AC_QUESTION_11,
            fieldLabel: AntiCorruptionLabel.AC_QUESTION_11
          }
        ]
      },
      {
        question:
          'Percentage of business partners that the organization’s anti-corruption policies and procedures have been communicated to, broken down by type of business partner and region. Describe if the organization’s anti-corruption policies and procedures have been communicated to any other persons or organizations.',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: AntiCorruptionKey.AC_QUESTION_12,
            fieldLabel: AntiCorruptionLabel.AC_QUESTION_12
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: AntiCorruptionKey.AC_QUESTION_13,
            fieldLabel: AntiCorruptionLabel.AC_QUESTION_13
          }
        ]
      },
      {
        question:
          'd. Total number of governance body members that have received training on anti-corruption, broken down by region.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: AntiCorruptionKey.AC_QUESTION_14,
            fieldLabel: AntiCorruptionLabel.AC_QUESTION_14
          }
        ]
      },
      {
        question:
          'Percentage of governance body members that have received training on anti-corruption, broken down by region.',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: AntiCorruptionKey.AC_QUESTION_15,
            fieldLabel: AntiCorruptionLabel.AC_QUESTION_15
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: AntiCorruptionKey.AC_QUESTION_16,
            fieldLabel: AntiCorruptionLabel.AC_QUESTION_16
          }
        ]
      },
      {
        question:
          'e. Total number of employees that have received training on anti-corruption, broken down by employee category and region.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: AntiCorruptionKey.AC_QUESTION_17,
            fieldLabel: AntiCorruptionLabel.AC_QUESTION_17
          }
        ]
      },
      {
        question:
          'Percentage of employees that have received training on anti-corruption, broken down by employee category and region.',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: AntiCorruptionKey.AC_QUESTION_18,
            fieldLabel: AntiCorruptionLabel.AC_QUESTION_18
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: AntiCorruptionKey.AC_QUESTION_19,
            fieldLabel: AntiCorruptionLabel.AC_QUESTION_19
          }
        ]
      }
    ]
  },
  {
    key: '3',
    label: AntiCorruptionLabel.AC_ANTI_CORRUPTION_3,
    kpiId: '205-3',
    items: [
      {
        question: 'a. Total number of confirmed incidents of corruption.',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: AntiCorruptionKey.AC_QUESTION_20,
            fieldLabel: AntiCorruptionLabel.AC_QUESTION_20
          }
        ]
      },
      {
        question: 'Nature of confirmed incidents of corruption.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: AntiCorruptionKey.AC_QUESTION_21,
            fieldLabel: AntiCorruptionLabel.AC_QUESTION_21
          }
        ]
      },
      {
        question:
          'b. Total number of confirmed incidents in which employees were dismissed or disciplined for corruption.',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: AntiCorruptionKey.AC_QUESTION_22,
            fieldLabel: AntiCorruptionLabel.AC_QUESTION_22
          }
        ]
      },
      {
        question:
          'c. Total number of confirmed incidents when contracts with business partners were terminated or not renewed due to violations related to corruption.',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: AntiCorruptionKey.AC_QUESTION_23,
            fieldLabel: AntiCorruptionLabel.AC_QUESTION_23
          }
        ]
      },
      {
        question:
          'd. Public legal cases regarding corruption brought against the organization or its employees during the reporting period and the outcomes of such cases.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: AntiCorruptionKey.AC_QUESTION_24,
            fieldLabel: AntiCorruptionLabel.AC_QUESTION_24
          }
        ]
      }
    ]
  }
];

export const antiCompetitiveBehaviorTabQuestions = [
  {
    key: '1',
    label: AntiCompetitiveBehaviorLabel.ACB_ANTI_COMPETITIVE_BEHAVIOUR_1,
    kpiId: '206-1',
    items: [
      {
        question:
          'a. Number of legal actions pending or completed during the reporting period regarding anti-competitive behavior and violations of anti-trust and monopoly legislation in which the organization has been identified as a participant.',
        field: [
          {
            fieldType: inputType.TEXT,
            fieldName: AntiCompetitiveBehaviorKey.ACB_QUESTION_1,
            fieldLabel: AntiCompetitiveBehaviorLabel.ACB_QUESTION_1
          }
        ]
      },
      {
        question:
          'b. Main outcomes of completed legal actions, including any decisions or judgments.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: AntiCompetitiveBehaviorKey.ACB_QUESTION_2,
            fieldLabel: AntiCompetitiveBehaviorLabel.ACB_QUESTION_2
          }
        ]
      }
    ]
  }
];

export const taxTabQuestions = [
  {
    key: '1',
    label: TaxLabel.T_TAX_1,
    kpiId: '207-1',
    items: [
      {
        question: 'a. A description of the approach to tax, including:',
        field: [
          {
            fieldType: inputType.HEADING,
            heading: TaxLabel.T_HEADING_1
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: TaxKey.T_QUESTION_1,
            fieldLabel: TaxLabel.T_QUESTION_1
          },
          {
            fieldType: inputType.HEADING,
            heading: TaxLabel.T_HEADING_2
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: TaxKey.T_QUESTION_2,
            fieldLabel: TaxLabel.T_QUESTION_2
          },
          {
            fieldType: inputType.HEADING,
            heading: TaxLabel.T_HEADING_3
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: TaxKey.T_QUESTION_2_1,
            fieldLabel: TaxLabel.T_QUESTION_2_1
          },
          {
            fieldType: inputType.HEADING,
            heading: TaxLabel.T_HEADING_4
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: TaxKey.T_QUESTION_2_2,
            fieldLabel: TaxLabel.T_QUESTION_2_2
          }
        ]
      }
    ]
  },
  {
    key: '2',
    label: TaxLabel.T_TAX_2,
    kpiId: '207-2',
    items: [
      {
        question:
          'a. A description of the tax governance and control framework, including: ',
        field: [
          {
            fieldType: inputType.HEADING,
            heading: TaxLabel.T_HEADING_5,
            tooltip:
              'If the highest governance body in an organization is accountable for compliance with the tax strategy, the organization can specify the degree to which the highest governance body has oversight of compliance. The organization can also specify any accountability for compliance delegated to executive-level positions within the organization.'
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: TaxKey.T_QUESTION_5,
            fieldLabel: TaxLabel.T_QUESTION_5
          },
          {
            fieldType: inputType.HEADING,
            heading: TaxLabel.T_HEADING_6,
            tooltip:
              'When reporting how the approach to tax is embedded within the organization, the organization can describe processes, projects, programs, and initiatives that support adherence to the approach to tax and tax strategy.'
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: TaxKey.T_QUESTION_6,
            fieldLabel: TaxLabel.T_QUESTION_6
          },
          {
            fieldType: inputType.HEADING,
            heading: TaxLabel.T_HEADING_7,
            tooltip:
              'Tax risks are risks associated with the organization’s tax practices that might lead to a negative effect on the goals of the organization, or to financial or reputational damage. These include compliance risks or risks such as those related to uncertain tax positions, changes in legislation, or a perception of aggressive tax practices. When reporting on the approach to tax risks, the organization can describe its risk appetite and tolerance and provide examples of tax practices it has avoided because they are misaligned with its approach to tax and tax strategy. Risk appetite and tolerance indicate the degree of risk the organization is willing to accept in determining its tax positions.'
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: TaxKey.T_QUESTION_7,
            fieldLabel: TaxLabel.T_QUESTION_7
          },
          {
            fieldType: inputType.HEADING,
            heading: TaxLabel.T_HEADING_8,
            tooltip:
              'When reporting how compliance with the tax governance and control framework is evaluated, the organization can describe the process through which the tax governance and control framework is monitored, tested, and maintained. An example of this is giving an internal auditor accountability for undertaking annual reviews of the tax department’s compliance with the tax governance and control framework. The organization can also specify the degree to which the highest governance body has oversight of the design, implementation, and effectiveness of the tax governance and control framework'
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: TaxKey.T_QUESTION_8,
            fieldLabel: TaxLabel.T_QUESTION_8
          }
        ]
      },
      {
        question:
          'b. A description of the mechanisms for reporting concerns about unethical or unlawful behavior and the organization’s integrity in relation to tax.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: TaxKey.T_QUESTION_9,
            fieldLabel: TaxLabel.T_QUESTION_9,
            tooltip:
              'One example of a mechanism for stakeholders to report concerns about unethical or unlawful behavior, or about activities that compromise the organization’s integrity in relation to tax, is whistleblowing'
          }
        ]
      },
      {
        question:
          'c. A description of the assurance process for disclosures on tax and, if applicable, a reference to the assurance report, statement, or opinion.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: TaxKey.T_QUESTION_10,
            fieldLabel: TaxLabel.T_QUESTION_10,
            tooltip:
              'If the assurance process for disclosures on tax has been completed as part of another assurance process, the organization can provide a reference to this information reported in Disclosure 102-56 or elsewhere.'
          }
        ]
      }
    ]
  },
  {
    key: '3',
    label: TaxLabel.T_TAX_3,
    kpiId: '207-3',
    items: [
      {
        question:
          'a. A description of the approach to stakeholder engagement and management of stakeholder concerns related to tax, including: ',
        field: [
          {
            fieldType: inputType.HEADING,
            heading: TaxLabel.T_HEADING_9,
            tooltip:
              'The approach to engagement with tax authorities can include participating in cooperative compliance agreements, seeking active real-time audit, seeking clearance for all significant transactions, engaging on tax risks, and seeking advance pricing agreements'
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: TaxKey.T_QUESTION_11,
            fieldLabel: TaxLabel.T_QUESTION_11
          },
          {
            fieldType: inputType.HEADING,
            heading: TaxLabel.T_HEADING_10,
            tooltip:
              'When reporting the approach to public policy advocacy on tax, the reporting organization can describe: • its lobbying activities related to tax. • its stance on significant issues related to tax that  it addresses in its public policy advocacy, and any  differences between its advocacy positions and its  stated policies, goals, or other public positions. • whether it is a member of, or contributes to, any representative associations or committees that participate in public policy advocacy on tax, including: - the nature of this contribution. - any differences between the organization’s stated policies, goals, or other public positions on significant issues related to tax, and the positions of the representative associations or committees.'
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: TaxKey.T_QUESTION_12,
            fieldLabel: TaxLabel.T_QUESTION_12
          },
          {
            fieldType: inputType.HEADING,
            heading: TaxLabel.T_HEADING_11,
            tooltip:
              'When reporting the processes for collecting and considering the views and concerns of stakeholders, the organization can describe how the processes enable stakeholders to participate in this engagement. The organization can also provide examples of how stakeholder feedback has influenced the approach to tax, the tax strategy, or the tax practices of the organization'
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: TaxKey.T_QUESTION_13,
            fieldLabel: TaxLabel.T_QUESTION_13
          }
        ]
      }
    ]
  },
  {
    key: '4',
    label: TaxLabel.T_TAX_4,
    kpiId: '207-4',
    items: [
      {
        question:
          'a. All tax jurisdictions where the entities included in the organization’s audited consolidated financial statements, or in the financial information filed on public record, are resident for tax purposes.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: TaxKey.T_QUESTION_14,
            fieldLabel: TaxLabel.T_QUESTION_14
          }
        ]
      },
      {
        question:
          'b. For each tax jurisdiction reported in Disclosure 207-4-a: ',
        field: [
          {
            fieldType: inputType.HEADING,
            heading: TaxLabel.T_HEADING_12
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: TaxKey.T_QUESTION_15,
            fieldLabel: TaxLabel.T_QUESTION_15
          },
          {
            fieldType: inputType.HEADING,
            heading: TaxLabel.T_HEADING_13
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: TaxKey.T_QUESTION_16,
            fieldLabel: TaxLabel.T_QUESTION_16
          },
          {
            fieldType: inputType.HEADING,
            heading: TaxLabel.T_HEADING_14
          },
          {
            fieldType: inputType.ADD_MORE_FIELDS,
            formList: {
              name: 'forEachTaxJurisdictionReportedInDisclosure',
              formFields: [
                {
                  type: inputType.COUNTRY,
                  fieldName: TaxKey.T_QUESTION_17,
                  fieldLabel: TaxLabel.T_QUESTION_17
                },
                {
                  type: inputType.NUMBER,
                  fieldName: TaxKey.T_QUESTION_18,
                  fieldLabel: TaxLabel.T_QUESTION_18
                }
              ]
            }
          },
          {
            fieldType: inputType.HEADING,
            heading: TaxLabel.T_HEADING_15
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: TaxKey.T_QUESTION_19,
            fieldLabel: TaxLabel.T_QUESTION_19
          },
          {
            fieldType: inputType.HEADING,
            heading: TaxLabel.T_HEADING_16
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: TaxKey.T_QUESTION_20,
            fieldLabel: TaxLabel.T_QUESTION_20
          },
          {
            fieldType: inputType.HEADING,
            heading: TaxLabel.T_HEADING_17
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: TaxKey.T_QUESTION_21,
            fieldLabel: TaxLabel.T_QUESTION_21
          },
          {
            fieldType: inputType.HEADING,
            heading: TaxLabel.T_HEADING_18
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: TaxKey.T_QUESTION_22,
            fieldLabel: TaxLabel.T_QUESTION_22
          },
          {
            fieldType: inputType.HEADING,
            heading: TaxLabel.T_HEADING_19
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: TaxKey.T_QUESTION_23,
            fieldLabel: TaxLabel.T_QUESTION_23
          },
          {
            fieldType: inputType.HEADING,
            heading: TaxLabel.T_HEADING_20
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: TaxKey.T_QUESTION_24,
            fieldLabel: TaxLabel.T_QUESTION_24
          },
          {
            fieldType: inputType.HEADING,
            heading: TaxLabel.T_HEADING_21
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: TaxKey.T_QUESTION_25,
            fieldLabel: TaxLabel.T_QUESTION_25
          }
        ]
      },
      {
        question:
          'c. The time period covered by the information reported in Disclosure 207-4.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: TaxKey.T_QUESTION_26,
            fieldLabel: TaxLabel.T_QUESTION_26
          }
        ]
      }
    ]
  }
];
